import {NgModule} from '@angular/core';
import {DOT_DUALIST_MODULE_CONFIGURE, DotDualistModule} from '@ng-dot/ui/dualist';
import {DOT_PAGINATION_MODULE_CONFIGURE} from '@ng-dot/ux/paginate';
import {DotRenderModule} from '@ng-dot/ui/render';
import {DotHttpStateService, DotRouteStateService, DotScrollStateService, DotStateModule} from '@ng-dot/ui/state';
import {DotToastModule} from '@ng-dot/ui/toast';
import {LayoutModuleConfigure} from './typings/layout-module-configure';
import {LAYOUT_CONFIGURE} from './tokens';

@NgModule({
	imports: [
		DotStateModule.forRoot(
			DotHttpStateService,
			DotRouteStateService,
			DotScrollStateService
		),
		DotToastModule.forRoot({
			defaultIcons: {
				low: 'icon24:message-low',
				medium: 'icon24:message-medium',
				high: 'icon24:message-high',
				critical: 'icon24:message-critical'
			}
		}),
		DotRenderModule.forRoot({
			totalProperty: 'meta.total',
			filterProperty: 'meta.filtered',
			itemsProperty: 'dataset',
			emptyComponent: {
				loadComponent: () => import('@im-ng/ui/empty').then(m => m.EmptyComponent),
				dataAs: {
					defined: 'defineId'
				}
			},
			errorComponent: {
				loadComponent: () => import('@im-ng/ui/error').then(m => m.ErrorComponent),
			}
		}),
		DotDualistModule.forRoot({
			sortToggleIcon: 'icon24:sort',
			sortAscIcon: 'icon24:sort-ascend',
			sortDescIcon: 'icon24:sort-descend',
			filterDatepickerIcon: 'icon24:calendar',
			filterSubmitIcon: 'icon24:search',
			filterCancelIcon: 'icon24:cancel',
			bodyZoneName: 'datatable'
		})
	]
})
export class LayoutModule {
	/**
	 * 레이아웃 모듈 활성화
	 * @example
	 * ```ts
	 * @NgModule({
	 *     imports: [
	 *         LayoutModule.forRoot()
	 *     ]
	 * })
	 * export class AppModule {
	 * }
	 * ```
	 * @see import('@ng-dot/ui/state').DotStateModule
	 * @see import('@ng-dot/ui/toast').DotToastModule
	 * @see import('@ng-dot/ui/render').DotRenderModule
	 * @see import('@ng-dot/ui/pagination').DotDualistModule
	 * @see import('@ng-dot/ui/dualist').DotDualistModule
	 * @param configure
	 */
	static forRoot(configure?: Partial<LayoutModuleConfigure>) {
		return {
			ngModule: LayoutModule,
			providers: [
				{
					provide: LAYOUT_CONFIGURE,
					useValue: configure
				},
				{
					provide: DOT_DUALIST_MODULE_CONFIGURE,
					multi: true,
					useValue: configure?.filter?.position ? {
						filter: {
							position: {
								top: 'head',
								bottom: 'foot',
								both: 'both'
							}[configure?.filter?.position]
						}
					} : {}
				},
				{
					provide: DOT_PAGINATION_MODULE_CONFIGURE,
					useValue: {
						icons: {
							before: 'icon24:arrow-line-head-tap-left',
							previous: 'icon24:arrow-line-head-left',
							next: 'icon24:arrow-line-head-right',
							after: 'icon24:arrow-line-head-tap-right',
							...(configure?.pagination?.icons)
						}
					}
				}
			]
		};
	}
}
